import React, {useState} from 'react'
import GenericBadge, {BadgeType, BadgeVariant} from '../../ui-components/Badge/GenericBadge'
import GenericButton from '../../ui-components/Button/GenericButton';

const BadgePlayground =() => {
  const [variant, setVariant] = useState<BadgeVariant>("brand");
  const [type, setType] = useState<BadgeType>("number");

  return (

    <section id="button" className="mb-10">
      <h2 className="text-2xl font-semibold mb-4">Badge</h2>
      <div className="flex items-center mb-4">
        <label className="mr-2 font-medium">Variant:</label>
        <select
          value={variant}
          onChange={(e) => setVariant(e.target.value as BadgeVariant)}
          className="border rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-400"
        >
          <option value="primary">Primary</option>
          <option value="brand">Brand</option>
          <option value="secondary">Secondary</option>
          
        </select>
      </div>
      <div className="flex items-center mb-4">
        <label className="mr-2 font-medium">Type:</label>
        <select
          value={type}
          onChange={(e) => setType(e.target.value as "number" | "dot")}
          className="border rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-400"
        >
          <option value="dot">Dot</option>
          <option value="number">Number</option>
        </select>
      </div>
      <GenericBadge 
        variant={variant}
        type={type}
        number={99}
      >
        <GenericButton  variant="brand" size="md" label='Button'/>
      </GenericBadge>
    </section>
  );
};

export default BadgePlayground